import { type FC } from 'react';

import type { PredictiveBudgetFieldProps } from '../../../../../../types/predictivePlanning.js';
import { useGetPredictiveValue } from '../hooks/useGetPredictiveValue.jsx';
import { FormattingSpanWrapper } from '../wrappers/FormattingSpanWrapper.jsx';

const PredictiveBudgetField: FC<PredictiveBudgetFieldProps> = (props) => {
  const { scale } = props.row.original;
  const { predictiveField } = useGetPredictiveValue(props);

  return (
    <FormattingSpanWrapper
      $scale={scale}
      color={(theme) => theme.palette.primary.dark}
    >
      {predictiveField}
    </FormattingSpanWrapper>
  );
};

export default PredictiveBudgetField;
